import type {
  PlatformHealthOverallStatus,
  PlatformHealthRow,
  PlatformHealthSummary,
} from '../types/operations.types';

export function deriveOverallStatus(
  failureCount: number,
  warningCount: number
): PlatformHealthOverallStatus {
  if (failureCount > 0) {
    return 'investigate';
  }
  if (warningCount > 0) {
    return 'review';
  }
  return 'healthy';
}

export function mergePlatformHealthSummaries(
  summaries: PlatformHealthSummary[],
  selectedDate?: string
): PlatformHealthRow[] {
  const byPlatform = new Map<string, PlatformHealthSummary>();

  for (const summary of summaries) {
    if (summary.source !== 'reconciliation') {
      continue;
    }
    byPlatform.set(summary.platform, summary);
  }

  return [...byPlatform.entries()]
    .map(([platform, reconciliation]) => {
      const reconciliationStatus = deriveOverallStatus(
        reconciliation.failure_count,
        reconciliation.warning_count,
      );

      return {
        platform,
        date: selectedDate ?? reconciliation.latest_check ?? '',
        reconciliation_status: reconciliationStatus,
        overall_status: reconciliationStatus,
      };
    })
    .sort((left, right) => left.platform.localeCompare(right.platform));
}
